export default {
    MATH_STUDENT: [
        {
            title: '关于登录问题',
            sublist: [
                {
                    title: '不知道账号和密码如何处理？',
                    innerlist: [
                        {
                            elword: '学校统一安排使用的同学，请联系任课老师获取账户登录信息，根据任课老师提供的账户及密码完成系统登录。',
                            elimg: require('@/assets/img/stufdback/help_01intro_01.png')
                        }
                    ]
                },
                {
                    title: '忘记密码怎么办？',
                    innerlist: [
                        {
                            elword: '在登录页面，点击输入密码框的右下角“忘记密码”，输入绑定的手机号码进行密码重置。',
                            elimg: require('@/assets/img/stufdback/help_01intro_02.png')
                        }
                    ]
                }
            ]
        },
        {
            title: '关于作业的问题',
            sublist: [
                {
                    title: '收不到老师布置的作业怎么办？',
                    innerlist: [
                        {
                            elword: '情况一：账号登录错误确认是否是登录任课老师统一提供的账号，若不是，请先在“设置”页面退出该账号，再登录老师提供的悠数学账号登录即可；'
                        },
                        {
                            elword: '情况二：老师还未布置作业请与数学任课老师确认是否布置作业；'
                        },
                        {
                            elword: '情况三：作业已布置还未到答题时间作业未到答题时间，在“作业记录”中是不显示的，待作业到答题时间即可在“作业记录”中查看并完成作业。'
                        }
                    ]
                },
                {
                    title: '填空题如何进行作答？',
                    innerlist: [
                        {
                            elword: '填空答案必须从“点击输入答案”框输入答案。仅拍照上传图片，系统默认未作答。',
                            elimg: require('@/assets/img/stufdback/help_02intro_02.png')
                        }
                    ]
                },
                {
                    title: '为什么作业被系统自动提交了？',
                    innerlist: [
                        {
                            elword: '情况一：作业到了系统截止时间每一份作业都会有系统截止时间，到了截止时间后，作业则会被系统自动提交，没法再继续做了。'
                        },
                        {
                            elword: '情况二：考试模式作业老师如果布置考试模式类型作业，在点击开始答题后，系统计时是不停止的，到了限定时间后，作业会被系统自动提交，还请同学们开始答题时注意咯~',
                            elimg: require('@/assets/img/stufdback/help_02intro_03.png')
                        }
                    ]
                }
            ]
        },
        {
            title: '关于批改有误的问题',
            sublist: [
                {
                    title: '发现批改有误时如何反馈？',
                    innerlist: [
                        {
                            elword: '当发现题目批改有误时，可点击批改结果下方的“题目批改有误，申诉重批”按钮进行申请二次批改',
                            elimg: require('@/assets/img/fdback/help_11ques_01.png')
                        },
                        {
                            elword: '填写批改错误的具体描述后，点击“提交”按钮，后台将重新对题目进行批改，后台批改完成后，将发送系统通知或短信告知用户',
                            elimg: require('@/assets/img/fdback/help_11ques_02.png')
                        },
                        {
                            elword: '说明：批改申诉仅支持申诉系统自动批改的填空题或解答题,如果该份作业中的解答题由老师批改，则无法进行申诉，请联系老师修改批改结果。'
                        }
                    ]
                }
            ]
        },
        // {
        //     title: '关于批改券使用',
        //     sublist: [
        //         {
        //             title: '如何使用批改券？',
        //             innerlist: [
        //                 {
        //                     elword: '系统面向悠数学会员用户每个月会分发一定数量的批改券，批改券主要用于VIP培优内自主练习试题解答题批改时所用，1张批改券可以自动批改1道解答题。',
        //                     elimg: require('@/assets/img/stufdback/help_04intro_01.png'),
        //                 },
        //                 {
        //                     elword: '批改券发放后会有一定的使用期限，请同学们一定要注意哦。',
        //                     elimg: require('@/assets/img/stufdback/help_04intro_02.png'),
        //                 }
        //             ]
        //         }
        //     ]
        // },
        {
            title: '关于错题本下载',
            sublist: [
                {
                    title: '如何下载错题本？',
                    innerlist: [
                        {
                            elword: '针对VIP培优会员用户，我们提供了错题本下载功能。',
                            elimg: require('@/assets/img/stufdback/help_05intro_01.png')
                        },
                        {
                            elword: '勾选需要下载的错题范围内容，点击生成错题本（如果需要下载错题多的话，需要耐心等待一会哦！），错题本生成后复制下载链接地址至电脑端下载该错题本word文档。',
                            elimg: require('@/assets/img/stufdback/help_05intro_02.png')
                        },
                        {
                            elimg: require('@/assets/img/stufdback/help_05intro_03.png')
                        },
                        {
                            elimg: require('@/assets/img/stufdback/help_05intro_04.png')
                        }
                    ]
                }
            ]
        },
        {
            title: '关于金币商城兑换时效性',
            sublist: [
                {
                    title: '关于金币商城兑换时效性',
                    innerlist: [
                        {
                            elword: '金币商城兑换后24小时工作日内会给予兑换，还请耐心等待，如兑换的是Q币类商品，请注意留下需要充值的QQ号；如兑换的是话费流量类商品，请注意留下需要充值的手机号；如兑换的是实际物品，请注意留下需要邮寄的地址信息。'
                        }
                    ]
                }
            ]
        },
        {
            title: '关于公式键盘如何使用',
            sublist: [
                {
                    title: '如何切换键盘？',
                    innerlist: [
                        {
                            elword: '在客户端“我-设置”中，你可以根据使用习惯和系统性能进行新老公式键盘的切换。',
                            elimg: require('@/assets/img/stufdback/help_06intro_11.png')
                        },
                        {
                            elimg: require('@/assets/img/stufdback/help_06intro_12.png')
                        },
                        {
                            elimg: require('@/assets/img/stufdback/help_06intro_13.png')
                        }
                    ]
                },
                {
                    title: '新键盘如何进行切换？',
                    innerlist: [
                        {
                            elword: '新版键盘提供了可视化公式、手写、中英文三种输入方式，三种键盘可以点击也可以滑动进行切换。',
                            elimg: require('@/assets/img/stufdback/help_06intro_21.png')
                        }
                    ]
                },
                {
                    title: '如何使用公式键盘进行内容输入？',
                    innerlist: [
                        {
                            elword: '1、请先选择您需要输入的公式；',
                            elimg: require('@/assets/img/stufdback/help_06intro_31.png')
                        },
                        {
                            elword: '2、选中需要输入内容的位置，直接输入内容；',
                            elimg: require('@/assets/img/stufdback/help_06intro_32.png')
                        },
                        {
                            elimg: require('@/assets/img/stufdback/help_06intro_33.png')
                        },
                        {
                            elword: '3、输入完成后，点击键盘右下角的【确认】按钮，完成填空题的答案输入。',
                            elimg: require('@/assets/img/stufdback/help_06intro_34.png')
                        }
                    ]
                },
                {
                    title: '如何使用手写键盘进行内容输入？',
                    innerlist: [
                        {
                            elword: '1、通过点击或者滑动切换至手写输入键盘；',
                        },
                        {
                            elword: '2、在手写区域书写内容，系统会自动识别书写内容，选择您需要填写的答案；',
                            elimg: require('@/assets/img/stufdback/help_06intro_41.png')
                        },
                        {
                            elimg: require('@/assets/img/stufdback/help_06intro_42.png')
                        },
                        {
                            elword: '3、选择正确的识别内容后，点击【确认】按钮完成输入。',
                            elimg: require('@/assets/img/stufdback/help_06intro_43.png')
                        }
                    ]
                }
            ]
        },
    ]
}



// WEBPACK FOOTER //
// ./src/mock/stufdbackintro.js